/** Grid layout shared with list filter toolbars. */
export const listFilterGridContainerSx = {
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
  alignItems: 'center',
} as const;

/** Single-row toolbar (edition, actions, filter, view). Wraps on narrow viewports — no horizontal scroll. */
export const listFilterSingleRowSx = {
  flexWrap: { xs: 'wrap', md: 'nowrap' },
  alignItems: 'center',
  width: '100%',
  minWidth: 0,
  overflowX: 'visible',
} as const;

/** Inline toolbar slot (modal/page header) — shrink-wrapped, no nested horizontal scroll. */
export const listFilterCompactRowSx = {
  flexWrap: 'nowrap',
  alignItems: 'center',
  width: 'auto',
  minWidth: 0,
  overflowX: 'visible',
} as const;

export const listFilterToolbarClusterSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  flexShrink: 0,
  width: { xs: '100%', md: 'auto' },
  minWidth: 0,
} as const;

export const listFilterToolbarEndSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  flexShrink: 0,
  flexWrap: 'wrap',
  marginLeft: { xs: 0, md: 'auto' },
  width: { xs: '100%', md: 'auto' },
  justifyContent: { xs: 'space-between', md: 'flex-end' },
} as const;

export const listFilterRowSpacing = 2;
export const listFilterColumnSpacing = { xs: 1.5, sm: 2, md: 2 } as const;

export const listFilterLeadingColumnSize = { xs: 12, md: 'auto' } as const;
export const listFilterActionsColumnSize = { xs: 12, md: 'auto' } as const;
export const listFilterSearchColumnSize = { xs: 12, md: 'grow' } as const;
export const listFilterToolbarEndColumnSize = { xs: 12, md: 'auto' } as const;

/** Inline toolbar search between actions and filter/view controls. */
export const listFilterToolbarSearchSx = {
  display: 'flex',
  alignItems: 'center',
  flex: { xs: '1 1 100%', md: '1 1 220px' },
  minWidth: { xs: 0, md: 220 },
  maxWidth: { xs: '100%', md: 480 },
  width: { xs: '100%', md: 'auto' },
} as const;

/** Sort direction toggle plus order-by field select. */
export const listFilterSorterRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  width: '100%',
  minWidth: 0,
} as const;
